class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.querySelector('html').classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.querySelector('html').classList.remove('overflow-hidden');
  }


  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('click', async (e) => {
    const button = e.target.closest('.pack-option');
    if (!button) return;

    const cartItem = button.closest('.cart-item');
    const cartItemTotalsSpinner = cartItem.querySelector('.cart-item__totals .loading__spinner');
    const newVariantId = button.dataset.variantId;
    const itemKey = cartItem.dataset.key;

    cartItem.classList.add('is-updating');
    cartItemTotalsSpinner.classList.remove('hidden');

    try {
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: itemKey,
                quantity: 0
            })
        });

        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: newVariantId,
                quantity: 1
            })
        });

        await refreshSections(['cart-drawer','cart-icon-bubble']);

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
        }

        async function refreshSections(sections = ['cart-drawer','cart-icon-bubble']) {
            try {
                const res = await fetch(`/?sections=${sections.join(',')}`, { credentials: 'same-origin' });

                const contentType = res.headers.get('content-type') || '';

                let htmlResponse = '';

                if (contentType.includes('application/json')) {
                    // Якщо сервер повернув JSON, беремо HTML з полів JSON
                    const json = await res.json();

                    // В JSON зазвичай ключі названі ідентифікаторами секцій,
                    // але щоб бути більш стійким - пробуємо кілька варіантів:
                    sections.forEach((section) => {
                        // json[section] часто містить HTML для секції
                        if (json[section]) {
                            htmlResponse += json[section];
                        } else if (json.sections && json.sections[section]) {
                            htmlResponse += json.sections[section];
                        } else if (typeof json[section] === 'string') {
                            htmlResponse += json[section];
                        }
                    });

                    // Якщо HTML всередині JSON екранований (має &quot; або додаткові лапки)
                    // декодуємо html-entities. Простий спосіб — використати тимчасовий textarea.
                    const textarea = document.createElement('textarea');
                    textarea.innerHTML = htmlResponse;
                    htmlResponse = textarea.value;

                } else {
                    // Якщо повернули plain HTML сторінки
                    htmlResponse = await res.text();
                }

                // Тепер парсимо отриманий HTML (він має бути чистим HTML строкою)
                const parser = new DOMParser();
                const newDoc = parser.parseFromString(htmlResponse, 'text/html');

                console.log(newDoc)

                sections.forEach((section) => {
                    // ідентифікатор секції у DOM зазвичай "shopify-section-{section}"
                    const expectedId = `shopify-section-${section}`;
                    // знаходимо новий елемент у parsed doc — кілька варіантів пошуку, щоб бути стійким

                    let newSection;
                    let currentSection;
                    if (section === 'cart-drawer') {
                        currentSection = document.getElementById(expectedId)
                            || document.querySelector(`#${CSS.escape(expectedId)}`)
                            || document.querySelector(`#CartDrawer .drawer__inner`);

                        newSection = newDoc.querySelector("#CartDrawer .drawer__inner ")
                            || newDoc.getElementById(expectedId)
                            || newDoc.querySelector(`[id*="${expectedId}"]`)
                            || (function(){
                                // іноді HTML приходить як просто <div data-section="cart-drawer">...
                                return newDoc.querySelector(`[data-section="${section}"]`) || null;
                            })()

                    } else if (section === 'cart-icon-bubble') {
                        currentSection = document.getElementById(expectedId)
                            || document.querySelector(`#${CSS.escape(expectedId)}`)
                            || document.querySelector("#cart-icon-bubble-inner");

                        newSection = newDoc.querySelector("#cart-icon-bubble-inner")
                            || newDoc.getElementById(expectedId)
                            || newDoc.querySelector(`[id*="${expectedId}"]`)
                            || (function(){
                                // іноді HTML приходить як просто <div data-section="cart-drawer">...
                                return newDoc.querySelector(`[data-section="${section}"]`) || null;
                            })()
                    }
                    console.log(newSection)
                    console.log(currentSection)

                    if (newSection && currentSection) {
                        currentSection.replaceWith(newSection);
                    } else {
                        // Для дебагу: якщо не знайшло — виведемо інфо в консоль
                        console.warn('Не змогли замінити секцію', section, { newSection, currentSection });
                    }
                });

            } catch (err) {
                console.error('refreshSections error', err);
            }
        }

    } catch (err) {
        console.error('Cart update failed:', err);
    } finally {
        cartItem.classList.remove('is-updating');
        cartItemTotalsSpinner.classList.add('hidden');
    }
});

// document.addEventListener('DOMContentLoaded', () => {
//
//     window.addEventListener('resize', () => {
//         cartScrollCreate();
//     })
//     cartScrollCreate();
//     function cartScrollCreate () {
//         document.querySelectorAll('cart-drawer cart-drawer-items .empty')?.forEach(function (emptyElement) {
//             emptyElement.style.minHeight = '';
//             emptyElement.style.minHeight = `${emptyElement.getBoundingClientRect().height+1}px`;
//         })
//     }
// })

